export default "__VITE_ASSET__DC0_rSBb__"